module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "positive-circle",
    style: (_vm.sizeStyle)
  }, [_c('icon', {
    staticClass: "positive-circle__plus",
    attrs: {
      "name": "plus",
      "scale": _vm.scale
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-704cd1d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/positiveityIndicator/PositiveCircle.vue
// module id = 1940
// module chunks = 0